<template>
  <div>
    <PCNavbar selectIndex="6-1" />
    <MobileNavBar :currentActive="5" />
    <div class="warp">
      <div class="enter_innovation_wrap">
        <div class="enter_img">
          <div class="img_tit hidden-xs-only">拓展合作</div>
          <div class="img_tit hidden-sm-and-up">拓展合作</div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="left">
        <div class="block">
          <el-timeline>
            <el-timeline-item timestamp="3/14" placement="top" color="#44546a">
              <el-card>
                <p>创建中心批复建设</p>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="4/11" placement="top" color="#44546a">
              <el-card>
                <p>
                  创新中心与施耐德签订《战略合作备忘录》，
                  共建全球首个氢能装备数字孪生与AI联合实验室
                </p>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="4/30" placement="top" color="#4472c4">
              <el-card>
                <p>
                  创新中心与中科富海签订《液氢装备检测和中试基地建设合作协议》，共建液氢装备检测和中试平台
                </p>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="5月" placement="top" color="#ed7d31">
              <el-card>
                <p>遴选国内头部企业，启动新一代氢能二轮车技术攻关及试点推广</p>
              </el-card>
            </el-timeline-item>
            <el-timeline-item timestamp="6月" placement="top" color="#a5a5a5">
              <el-card>
                <p>
                  牵头环杭州湾氢能先进装备集群组建及应用推广;与嘉兴南湖学院共建人才中心（推进中）
                </p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
      <div class="right">
        <div class="top">
          <img src="../../assets/he1.png" alt="" />
          <img src="../../assets/he2.png" alt="" />
        </div>
        <div class="bottom">
          <div class="img" v-for="(item, index) in cardlist" :key="index">
            <img :src="item.path" alt="" />
          </div>
        </div>
      </div>
    </div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import CallMe from "@/components/callme/index";
import MobileCallme from "@/components/callme/MobileCallme.vue";
import PCNavbar from "@/components/navbar/index";
import MobileNavBar from "@/components/navbar/MobileNavBar.vue";
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe,
    MobileCallme,
  },
  data() {
    return {
      cardlist: [
        {
          path: require("@/assets/he3.png"),
        },
        {
          path: require("@/assets/he4.png"),
        },
        {
          path: require("@/assets/he5.png"),
        },
        {
          path: require("@/assets/he6.png"),
        },
        {
          path: require("@/assets/he7.png"),
        },
        {
          path: require("@/assets/he8.png"),
        },
        {
          path: require("@/assets/he9.png"),
        },
        {
          path: require("@/assets/he10.png"),
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.enter_innovation_wrap {
  width: 100%;
  .enter_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url("../../assets/hezuo.jpg") 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        text-align: center;
      }
    }
    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      text-align: center;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }
  }
}
.content {
  width: 90%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 40px 0;
  .left {
    width: 45%;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
  .right {
    width: 45%;
    .top {
      width: 80%;
      position: relative;
      margin: auto;
      height: 400px;
      @media screen and (max-width: 768px) {
        height: 200px;
      }
      img {
        position: absolute;
        width: 50% !important;
        &:nth-child(2) {
          left: 40%;
        }
      }
    }
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
  .bottom {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .img {
      width: 25%;
      img {
        width: 100%;
        height: 120px;
        @media screen and (max-width: 768px) {
          height: 60px;
        }
      }
    }
  }
}
</style>